const dateTimeFormats = {
  es: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    long: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  en: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  fr: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  de: {
    dayShort: {
      day: "2-digit"
    },
    dayText: {
      weekday: "long"
    },
    monthText: {
      month: "long"
    },
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZoneName: "short",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }
};

export default dateTimeFormats;
